export const TOGGLE_TAB_GROUP_OPTIONS = {
    ALL_LINKS: 'all_links',
    STANDARD_LINKS: 'standard_links',
    AGENCY_LINKS: 'agency_links',
    API_LINKS: 'api_links',
    OLD_LINKS: 'old_links',
};
